import React, { useCallback, useEffect, useState } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Box, Button, Grid, MenuItem, Select } from '@material-ui/core';
import { SpecialProjectsFilter, useCitiesQuery } from '../../../../schema';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    search: {
      paddingRight: theme.spacing(2),
    },
    resetButton: {
      display: 'block',
      marginLeft: 'auto',
    },
    selectLabel: {
      margin: '10px',
    },
  })
);

export type SpecialProjectSearchProps = {
  onSearchCity?: (city: string | undefined) => void;
  onSpecialProjectsFilterChange?: (filter: SpecialProjectsFilter) => void;
};

export const SpecialProjectSearch = (props: SpecialProjectSearchProps) => {
  const { onSearchCity, onSpecialProjectsFilterChange } = props;

  const classes = useStyles();

  const { data } = useCitiesQuery();
  const cities = data?.cities ? (data?.cities.nodes?.map(({ name }) => name) as string[]) : [];
  const [city, setCity] = useState<string>('');
  const [filter, setFilter] = useState<SpecialProjectsFilter>(SpecialProjectsFilter.Active);

  const handleChangeCity = (e: React.ChangeEvent<{ value: unknown }>) => {
    setCity(e.target.value as string);
  };
  console.log(onSpecialProjectsFilterChange);

  const handleChangeFilter = (e: React.ChangeEvent<{ value: unknown }>) => {
    const newFilter = e.target.value as SpecialProjectsFilter;
    setFilter(newFilter);

    // Обновляем новый фильтр
    if (onSpecialProjectsFilterChange !== undefined) {
      onSpecialProjectsFilterChange(newFilter);
    }
  };

  useEffect(() => {
    if (onSearchCity !== undefined) {
      onSearchCity(city);
    }
  }, [onSearchCity, city]);

  // Инициализируем фильтр только один раз при монтировании
  useEffect(() => {
    if (onSpecialProjectsFilterChange !== undefined) {
      onSpecialProjectsFilterChange(SpecialProjectsFilter.Active);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOnReset = useCallback(() => {
    setFilter(SpecialProjectsFilter.Active);
    setCity('');

    if (onSearchCity) {
      onSearchCity('');
    }

    if (onSpecialProjectsFilterChange) {
      onSpecialProjectsFilterChange(SpecialProjectsFilter.Active);
    }
  }, [onSearchCity, onSpecialProjectsFilterChange]);

  return (
    <div className={classes.root}>
      <Grid container spacing={4} className={classes.root}>
        <Grid item lg={3} md={4} xl={2} xs={12}>
          <Box display="flex" alignItems="center">
            <h4 className={classes.selectLabel}>Город:</h4>
            <Select value={city} variant={'outlined'} displayEmpty onChange={handleChangeCity}>
              <MenuItem disabled value={''}>
                Выберите город
              </MenuItem>
              {cities.map((item) => (
                <MenuItem value={item}>{item}</MenuItem>
              ))}
            </Select>
          </Box>
        </Grid>
        <Grid item lg={3} md={4} xl={2} xs={12}>
          <Box display="flex" alignItems="center">
            <h4 className={classes.selectLabel}>Завершенность:</h4>
            <Select value={filter} displayEmpty variant={'outlined'} onChange={handleChangeFilter}>
              <MenuItem value={SpecialProjectsFilter.Active}>Актуальные (сборы)</MenuItem>
              <MenuItem value={SpecialProjectsFilter.Collected}>
                Собранные, но не завершенные
              </MenuItem>
              <MenuItem value={SpecialProjectsFilter.Complete}>Завершенные</MenuItem>
              <MenuItem value={SpecialProjectsFilter.NotPublished}>Неопубликованные</MenuItem>
              <MenuItem value={SpecialProjectsFilter.All}>Все</MenuItem>
            </Select>
          </Box>
        </Grid>

        <Grid item lg={6} md={4} xl={8} xs={12}>
          <Button className={classes.resetButton} variant="contained" onClick={handleOnReset}>
            Сбросить фильтры
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};
